__turbopack_context__.v({
  "frame": "ceo-message-module__gPfR_q__frame",
  "image": "ceo-message-module__gPfR_q__image",
  "overlay": "ceo-message-module__gPfR_q__overlay",
  "portrait": "ceo-message-module__gPfR_q__portrait",
  "profile": "ceo-message-module__gPfR_q__profile",
  "pulse": "ceo-message-module__gPfR_q__pulse",
  "track": "ceo-message-module__gPfR_q__track",
  "track-pulse": "ceo-message-module__gPfR_q__track-pulse",
});
